import { Input } from '@/components/ui/input'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormEntityContext } from '../../config/context/forms'
import FieldWrapper from './FieldWrapper'
import { FormField } from '@/components/ui/form'
import { FieldProps } from './types'
import { cn } from '@/lib/utils'

const NumberField = ({
  name,
  customDescription,
  customLabel,
  customPlaceholder,
  layout = 'box',
  className,
  inputClassName,
  ...inputProps
}: FieldProps<number>) => {
  const { t } = useTranslation()
  const form = useFormContext()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  return (
    <div className={`${layout === 'inline-shrinkable' ? '' : 'w-full'}`}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => {
          return (
            <FieldWrapper
              layout={layout}
              label={
                customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
              }
              description={
                customDescription ??
                t(`${i18nPrefix}.${entityType}.${name}.description`)
              }
            >
              <Input
                type={'number'}
                placeholder={t(
                  customPlaceholder ??
                    `${i18nPrefix}.${entityType}.${name}.placeholder`,
                )}
                className={cn(
                  layout == 'box' ? `absolute right-3 top-1.5 w-24 z-20` : '',
                  className,
                  inputClassName,
                )}
                {...field}
                {...inputProps}
                onChange={(event) =>
                  field.onChange?.(parseInt(event.target.value, 10) || null)
                }
              />
            </FieldWrapper>
          )
        }}
      />
    </div>
  )
}

export default NumberField
